<template>
  <div class="search-reports" :alt="lang">
    <!-- <div class="search-img">
        <div class="img-ss">
            <img class="search-background" src="../assets/images/searchbackground.jpg" />
            <h1 class="search-title">{{$t('NavabarText.navbar_search')}}</h1>
        </div>
    </div> -->
    <span style="display: none">{{lang}}</span>
    <sub-banner>
      <img src="../assets/images/search/search.jpg"/>
      <div slot="title">
        {{$t('footText.report')}}
      </div>
      <a href="/" slot="action">{{$t('footText.back')}}</a>
    </sub-banner>


    <div class="bg_c">
      <div class="search-content">
        <div class="content-item-right-bg">
          <div class="content-item-right">
            <div class="content-item-input">
              <div class="tip"><span class="icon iconfont iconhoushinianxingming iconclass"></span> <span class="label">{{$t('ContractText.name')}}</span></div>
              <input type="text" class="item-input" v-model="searchForm.Name">
            </div>
            <div class="content-item-input">
              <div class="tip"><span class="icon iconfont iconzhengjian iconclass"></span> <span class="label">{{$t('ContractText.code')}}</span></div>
              <input type="text" class="item-input" v-model="searchForm.LaboratoryNo">
            </div>
            <div id="your-dom-id" class="nc-container content-item-input"></div>

            <input class="input-form" id="token" style="display:none"/>
            <input class="input-form" id="sessionId" style="display:none"/>

            <input class="input-form" id="sig" style="display:none"/>
            <!-- <div class="content-item-input">
                <div class="select-area">
                        <select id="selArea" class="select" v-model="searchForm.areaNo">
                            <option value="86">{{$t('ContractText.cn')}}</option>
                            <option value="00852">{{$t('ContractText.hk')}}</option>
                            <option value="00853">{{$t('ContractText.mo')}}</option>
                        </select>
                        <div class="tip"><span class="icon iconfont icondianhua11 iconclass"></span> <span class="label">{{$t('ContractText.phone')}}</span></div>
                        <input class="input-form" value='' v-model="searchForm.Phone" Id="Phone"/>
                </div>

            </div> -->
            <!-- <div class="content-item-input">
                <div class="select-area">
                    <input type="text" class="input-forms"  v-model="searchForm.vertify" :placeholder="$t('ContractText.vertifys')" >
                    <span id="daoshushijian" class="error-img"></span>
                     <button  id="send-sms" class="form-btn-send" type="button" @click="sendMsg()"  :class="i<30?'send_smsspe':''" :disabled="i<30?true:false">
                        <span v-if="numTimer<1">{{$t('ContractText.send_sms')}}</span>
                        <span v-if="numTimer>=1">{{$t('ContractText.send_sms_second')}}</span>
                    </button>
                    <button  id="send-sms" class="form-btn-send" type="button" @click="SendMessagesByVoice()"  v-if="numTimer>=1||i<30" :class="i<30?'send_smsspe':''" :disabled="i<30?true:false">
                        <span >{{$t('ContractText.speaker')}}</span>
                    </button>

                </div>
            </div> -->
            <!-- <div class="content-item-input">
                <div class="sms-speaker" @click="SendMessagesByVoice()" v-if="numTimer>=2"></div>
            </div> -->
            <div class="content-item-inputs">
              <div class="select-warning">
                <div class="checekboxs-div">
                  <input type="checkbox" :checked="checked" class="checekboxs">
                </div>
                <div class="warning">{{$t('ContractText.warning')}}
                  <a target="_blank" href="/static/香港醫務檢測中心有限公司私隱政策.pdf">
                    <span style="color:#1cba9f;border-bottom:1px solid #1cba9f;cursor: pointer;">{{$t('ContractText.statement')}}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="content-item-input">
              <div classs="submit-div">
                <button class="submit-btn" type="button" @click="submit()">{{$t('ContractText.mailbox_btn')}}</button>
              </div>

            </div>
          </div>
        </div>
        <div class="content-item-left">
          <div class="item-left">
            <div class="item-title">{{$t('ContractText.report_search_description')}}</div>
            <ol>
              <li class="item-content">{{$t('ContractText.description_one')}}</li>
              <li class="item-content">{{$t('ContractText.description_two')}}</li>
              <!-- <li class="item-content">{{$t('ContractText.description_three')}}</li> -->
              <li class="item-content">{{$t('ContractText.description_four')}}</li>
              <!-- <li class="item-content">{{$t('ContractText.description_five')}}</li> -->
              <li class="item-content" v-html="$t('ContractText.description_five')"></li>

            </ol>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-dialog title="" :visible.sync="dialogImgVisible" width="50%" :show-close='true'>
        <div>
          <div style="width:100%;text-align:right;margin-right:32px;margin-bottom:10px;">
            <div class="btn_div">
              <a class="btn_down" style="color:#fff;font-size:16px;cursor: pointer;" @click="downloadPdf()">
                <span v-if="$store.state.lang=='zh-TCC'">下載報告</span>
                <span v-if="$store.state.lang=='zh-CN'">下载报告</span>
                <span v-if="$store.state.lang=='en-US'">Download</span>
                <span class="icon iconfont iconbaocun baocun"></span>
              </a>
            </div>
          </div>
          <div>
            <img id="fullResImage" :src="PdfImgUrl" style="height: 100%; width: 100%;">
          </div>
        </div>

      </el-dialog>
    </div>
  </div>
</template>


<!--引入guide.js前必须已定义NVC_Opt。-->
<!--<script src="//g.alicdn.com/sd/nvc/1.1.112/guide.js"></script>-->

<!-- 国内使用 -->
<!--<script type="text/javascript" charset="utf-8" src="//g.alicdn.com/sd/ncpc/nc.js?t=2015052012"></script>-->
<!-- 若您的主要用户来源于海外，请替换使用下面的js资源 -->
<!-- <script type="text/javascript" charset="utf-8" src="//aeis.alicdn.com/sd/ncpc/nc.js?t=2015052012"></script> -->
<script>
  import {
    SendMessage, LoginsImg, SendMessagesVoice,
    LoginAliYun,
  } from '@/service/searchreport'
  import banner from '@/components/banner'
  import SubBanner from "../components/sub-banner";

  var nc_token = ["FFFF0N0N000000009486", (new Date()).getTime(), Math.random()].join(':');
  var NVC_Opt = {
      renderTo: "#your-dom-id",
      appkey: "FFFF0N0N000000009486",
      scene: "nc_login",
      token: nc_token,
      customWidth: 300,
      trans: {"key1": "code0"},
      elementID: ["usernameID"],
      is_Opt: 0,
      language: "cn",
      isEnabled: true,
      timeout: 3000,
      times: 5,
      apimap: {
        // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
        // 'get_captcha': '//b.com/get_captcha/ver3',
        // 'get_captcha': '//pin3.aliyun.com/get_captcha/ver3'
        // 'get_img': '//c.com/get_img',
        // 'checkcode': '//d.com/captcha/checkcode.jsonp',
        // 'umid_Url': '//e.com/security/umscript/3.2.1/um.js',
        // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
        // 'umid_serUrl': 'https://g.com/service/um.json'
      },
      callback: function (data) {
        window.console && console.log(data)
        window.console && console.log(nc_token)
        window.console && console.log(data.csessionid)
        window.console && console.log(data.sig)
        document.getElementById('token').value = data.token;
        document.getElementById('sessionId').value = data.csessionid
        document.getElementById('sig').value = data.sig
        window.Token = data.token;
        window.sessionId = data.csessionid;
        window.sig = data.sig;
      }
    }
  window.NVC_Opt = NVC_Opt
  export default {
    data() {
      return {
        loaded: false,
        searchForm: {
          areaNo: '86',
          LaboratoryNo: '',
          Name: '',
          Phone: '',
          vertify: '',
        },
        error: false,
        i: 30,
        flag: 1,
        timer: null,
        checked: true,
        numTimer: 0,
        isDisabled: false,
        dialogImgVisible: false,
        PdfImgUrl: '',
        pdfUrl: '',
        sessionId: '',
        sig: '',
        Token: ''
      }
    },
    components: {
      SubBanner,
      banner,

    },
    created() {
      this.get_ALY_file();
    },
    mounted() {
      window.onload =  () => {
        this.setOption();
        this.createScript()
      }
    },
    computed: {
      lang: function () {
        let lang = this.$i18n.locale;

        if (this.loaded) {
          this.setOption();
          //第二次view才会更新
          this.setOption();
        }
        return lang;
      }
    },
    methods: {
      setOption() {
        let lang = this.$i18n.locale;
        let startText = '請按住滑塊，拖動到最右邊';
        let yesText = '驗證通過';
        if (lang === 'en-US') {
          startText = 'Drag the slider to the right';
          yesText = 'Verified Successfully';
        }
        let nc = new noCaptcha(NVC_Opt)
        nc.upLang('cn', {
          _startTEXT: startText,
          _yesTEXT: yesText,
          _error300: "出錯啦，點擊<a href=\"javascript:__nc.reset()\">刷新</a>再來一次",
          _errorNetwork: "網絡錯誤，請<a href=\"javascript:__nc.reset()\">點擊刷新</a>",
        })

        if (!this.loaded) {
          this.loaded = true;
        }
      },
      createScript() {
        var script = document.createElement("script");  //创建一个script标签
        script.id = "tag";
        script.type = "text/javascript";
        script.src = "//g.alicdn.com/sd/nvc/1.1.112/guide.js";
        document.getElementsByTagName('head')[0].appendChild(script);
      },
      get_ALY_file() {
        try {
          var stamp = new Date().getTime();
          var script = document.createElement('script');
          script.setAttribute('type', 'text/javascript');
          script.setAttribute('src', 'https://g.alicdn.com/sd/ncpc/nc.js?t=' + stamp);
          document.documentElement.appendChild(script);
        } catch (e) {

        }
      },
      validated() {
        let areaNo = this.searchForm.areaNo + '';
        let phone = this.searchForm.Phone + '';
        if (areaNo === '86' && phone.length !== 11) {
          alert('請輸入11位内地電話號碼！');
          return false;
        }
        if (areaNo !== '86' && phone.length !== 8) {
          alert('請輸入8位香港（澳门）電話號碼！');
          return false;
        }
        return true;

      },
      liJumps(path) {
        this.$router.push({
          path: path
        })
      },
      //发送短信验证码
      sendMsg() {
        if (this.searchForm.LaboratoryNo == '') {
          alert('請輸入報告編號！');
          return;
        }
        if (this.searchForm.Name == '') {
          alert('請輸入受測者姓名！')
          return;
        }
        if (this.searchForm.Phone == '') {
          alert('請輸入電話號碼！')
          return;
        }
        if (!this.validated()) return;

        this.SendMessages();
      },
      //查询报告
      submit() {
        console.log('sdfd', this.searchForm);
        if (this.searchForm.LaboratoryNo == '') {
          alert('請輸入報告編號！');
          return;
        }
        if (this.searchForm.Name == '') {
          alert('請輸入受測者姓名！')
          return;
        }
        // if(this.searchForm.Phone==''){
        //     alert('請輸入電話號碼！')
        //     return;
        // }
        // if(this.searchForm.vertify==''){
        //     alert('請輸入驗證碼！')
        //     return;
        // }
        this.Logins()
      },

      countDown() {
        if (!this.timer) {
          this.timer = setInterval(() => {
            this.i = this.i - 1;
            if (this.i < 30) {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }
            if (this.i < 0) {
              this.i = 0;
            }
            $("#daoshushijian").html(this.i + 's');
            if (this.i == 0) {
              $("#daoshushijian").html("");
              document.getElementById('send-sms').disabled = false;
              this.flag = 1;
              this.i = 30;

              clearInterval(this.timer);
              this.timer = null;
              this.numTimer++;
              return;
            }
          }, 1000);
        }
      },
      async SendMessages() {
        let resp = await SendMessage(this.searchForm.LaboratoryNo, this.searchForm.Name, this.searchForm.areaNo + this.searchForm.Phone);
        if (resp.Status) {
          if (resp.Status == true) {
            alert("短信已发送，请注意查收");
            //每秒调用countDown方法，显示动态时间效果
            this.countDown();
          } else {
            alert("短信发送失败：" + resp.Msg)
            document.getElementById('send-sms').disabled = false;
          }
        } else {
          alert(resp.Msg)
        }
      },
      SendMessagesByVoice() {
        if (this.searchForm.LaboratoryNo == '') {
          alert('請輸入報告編號！');
          return;
        }
        if (this.searchForm.Name == '') {
          alert('請輸入受測者姓名！')
          return;
        }
        if (this.searchForm.Phone == '') {
          alert('請輸入電話號碼！')
          return;
        }
        if (!this.validated()) return;

        //  this.SendMessagesVoice();
      },
      /**
       * 語音發送
       */
      async SendMessagesVoice() {
        let resp = await SendMessagesVoice(this.searchForm.LaboratoryNo, this.searchForm.Name, this.searchForm.areaNo + this.searchForm.Phone);
        // if(resp){
        //     if(resp.Status==true){
        alert("即將撥打電話至你的手機，请注意接聽電話！");
        //每秒调用countDown方法，显示动态时间效果
        this.countDown();
        //     }else{
        //         alert("短信发送失败："+resp.Msg)
        //         document.getElementById('send-sms').disabled=false;
        //     }
        // }else{
        //     alert(resp.Msg)
        // }
      },
      async Logins() {
        //let resp=await LoginsImg(this.searchForm.LaboratoryNo,this.searchForm.Name,this.searchForm.Phone,this.searchForm.vertify)
        var token = document.getElementById('token').value;
        var sig = document.getElementById('sig').value;
        var sessionId = document.getElementById('sessionId').value;
        let data = {
          LaboratoryNo: this.searchForm.LaboratoryNo,
          Name: this.searchForm.Name,
          Phone: this.searchForm.Phone,
          SessionId: sessionId,
          Token: token,
          Sig: sig,
          Scene: 'nc_login',
          FromType: 'PC'
        };

        let resp = await LoginAliYun(data)
        if (resp.Status) {

          let report = resp.Data;
          if (report == null) {
            //无报告
            alert("沒有查詢到您的相關報告信息，如有疑問請聯繫我們 +852 2865 9399");
            return;
          }
          var beforeFiveOne = new Date(Date.parse('2020/05/07 00:00:00'));//五一前的报告跳转到 不同页面
          var reportDate = new Date(report.ReportDate);
          if (beforeFiveOne > reportDate) {
            this.$store.commit('setReportData', report);
            this.$router.push({
              path: '/reportoldresult'
            })
          } else {
            // sessionStorage.setItem('ReportData', JSON.stringify(report));
            //window.open( process.env.BASE_URL + '/' + report);
            var reports = report.PdfUrlImg.replace("\\", "\/").replace("\\", "\/").split('/');
            console.log(reports);
            var newreports = report.PdfUrlImg.replace(reports[reports.length - 1], "web" + reports[reports.length - 1])
            this.PdfImgUrl = process.env.BASE_URL + '/' + newreports;
            //this.dialogImgVisible=true;
            this.pdfUrl = process.env.BASE_URL + '/' + resp.Data.PdfUrl.replace('jpg', 'pdf');
            window.open(this.pdfUrl);
          }
        } else {
          alert("登錄失敗：" + resp.Msg)
        }
      },
      isMobileDevice() {
        let isMobile = false;
        let thisOS = navigator.platform,
          userAgent = navigator.userAgent,
          appVersion = navigator.appVersion;
        let os = ["iPhone", "iPod", "iPad"]//"android","Nokia","SymbianOS","Symbian","Windows Phone","Phone","Linux armv71","MAUI","UNTRUSTED/1.0","Windows CE","BlackBerry","IEMobile"];
        for (let i = 0; i < os.length; i++)
          if (thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
            isMobile = true;

        //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
        if (navigator.platform.indexOf('iPad') != -1)
          isMobile = true;

        return isMobile;
      },
      downloadPdf() {
        if (this.isMobileDevice()) {//是苹果手机 无法下载 请到电脑端下载
          alert("由於蘋果IOS系統相關政策不能為您提供下載服務，您可通關電腦端下載您的報告，不便之處，敬請諒解");
          return;
        } else {
          window.open(this.pdfUrl);
          //this.fileLinkToStreamDownload(this.pdfUrl,'报告下载','application/pdf');
        }
      },
      /**
       * 文件链接转文件流下载--主要针对pdf 解决谷歌浏览器a标签下载pdf直接打开的问题
       * @param url  ：文件链接
       * @param fileName  ：文件名;
       * @param type  ：文件类型;
       */
      fileLinkToStreamDownload(url, fileName, type) {
        console.log(url);
        let that = this
        url = url.replace("\\", "\/").replace("\\", "\/")
        let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;

        let xhr = new XMLHttpRequest();
        xhr.open('get', url, true);
        xhr.setRequestHeader('Content-Type', `application/${type}`);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (that.status == 200) {
            //接受二进制文件流
            var blob = this.response;
            that.downloadExportFile(blob, fileName, type)
          }
        }
        xhr.send();

      },
      /**
       *下载导出文件
       * @param blob  ：返回数据的blob对象或链接
       * @param tagFileName  ：下载后文件名标记
       * @param fileType  ：文件类 word(docx) excel(xlsx) ppt等
       */
      downloadExportFile(blob, tagFileName, fileType) {
        let downloadElement = document.createElement('a');
        let href = blob;
        if (typeof blob == 'string') {
          downloadElement.target = '_blank';
        } else {
          href = window.URL.createObjectURL(blob); //创建下载的链接
        }
        downloadElement.href = href;
        downloadElement.download = tagFileName + (new Date().getTime()).format('YYYYMMDDhhmmss') + '.' + fileType; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        if (typeof blob != 'string') {
          window.URL.revokeObjectURL(href); //释放掉blob对象
        }

      },
    }

  }
</script>

<style lang="scss" scoped>

  @import '../assets/font/iconfont.css';

  .search-reports {
    width: 100%;

    margin-top: 1rem;
    text-align: center;
    position: relative;

    .search-img {
      margin: 0 auto;

      .img-ss {
        position: relative;

        .search-background {
          max-width: 100%;
          height: auto;
          position: relative;
        }

        .search-title {
          width: 100%;
          height: 100%;
          font-size: 47px;
          line-height: 60px;
          color: #fff;
          position: absolute;
          display: flex;
          justify-content: left;
          align-items: center;
          padding-left: 10%;
          padding-right: 10%;
          font-weight: bold;
          top: 0;
        }

        .search-title:before {
          display: table;
          content: " ";
        }

        .search-title:after {
          display: table;
          content: " ";
        }

      }

    }

    .page_tip {
      background-color: #fff;
      height: 130px;
      margin-top: -130px;
      position: relative;
      z-index: 9999;
      color: #fff;

      .tip_content {
        background: url('/static/images/greenbar.png') no-repeat;
        background-position: center center;
        background-size: 100% auto;
        height: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tip_search {
          margin-left: 21%;
          font-family: AlibabaPuHuiTi-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 9px;
          letter-spacing: 0px;
          color: #ffffff;
        }

        .tip_home {
          margin-right: 28%;
          font-family: AlibabaPuHuiTi-Regular;
          text-decoration: underline;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 9px;
          letter-spacing: 0px;
          color: #1bb89d;
          cursor: pointer;
        }
      }
    }

    .bg_c {
      background: url('/static/images/search_bg.png') no-repeat;
      background-position: center center;
      background-size: 100% auto;
    }

    .search-content {
      clear: both;
      width: 80%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: auto;
      margin-top: 10rem;
      padding-bottom: 10rem;

      box-sizing: border-box;

      .content-item-left {
        //   max-width: 1180px;
        //min-width: 300px;
        max-width: 610px;
        min-width: 610px;
        margin-left: 10rem;

        .item-left {
          text-align: left;

          ol {
            padding-inline-start: 20px !important;
          }

          li {
            padding-left: 18px;
          }

          .item-title {
            color: #368da7;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 6rem;
            font-family: AlibabaPuHuiTi-Medium;
            font-size: 38px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
            color: #000000;
            margin-top: 1rem;
            white-space: nowrap;
          }

          .item-content {
            list-style-position: outside;
            font-family: AlibabaPuHuiTi-Light;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #000000;
            line-height: 40px;

          }
        }
      }

      .content-item-right-bg {
        background: url('/static/images/search_info_bg.png') no-repeat;
        background-size: 100% 100%;
      }

      .content-item-right {
        min-width: 444px;
        margin-right: 10px;
        padding-top: 30px !important;
        padding-right: 30px !important;
        padding-bottom: 10px !important;
        padding-left: 30px !important;
        //background-color: #e9e9e9!important;
        opacity: 0.8;

        .content-item-input {
          position: relative;
          margin-bottom: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          &:nth-child(3) {
            justify-content: center;

          }

          &:nth-child(3)::after {
            height: 0px;
          }

          &:last-child {
            justify-content: center;

          }

          &:last-child::after {
            height: 0px;
          }

          &:nth-child(5) {

          }

          &:nth-child(5)::after {
            height: 0px;;
          }

          &:nth-child(4) {
            width: 10%;
            justify-content: center;
          }

          &:nth-child(4)::after {
            height: 0px;


          }

          &:nth-child(4) .select-area {
            width: 100%;
            clear: both;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            align-items: center;
          }

          .tip {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .iconclass {
              color: #fff;
              font-size: 18px;
            }

            .label {
              margin-right: 2px;
              color: #2a2a2a;
              font-family: AlibabaPuHuiTi-Light;
              font-size: 15px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 18px;
              letter-spacing: 0px;
              color: #2a2a2a;
            }
          }

          .select-area {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            box-sizing: border-box;

            .select {
              border-color: #fff;
              background: #fff;
              border-width: 1px;
              border-style: solid;
              color: #2a2a2a;
              font-family: Arial;
              font-size: 14px;
              line-height: 18px;
              font-style: normal;
              font-weight: 400;
              letter-spacing: 0px;
              text-transform: none;
              padding-top: 10px;
              padding-bottom: 10px;
              margin-top: 0px;
              margin-bottom: 0px;
              padding-left: 10px;
              margin-right: 20px;
            }

            .select option {
              background: #fff !important;
              color: #2a2a2a;
              padding-top: 15px !important;
              padding-bottom: 15px !important;
            }

            .select:active {
              background: #1cba9f !important;
              color: #fff;
            }

            .select:visited {
              background: #1cba9f !important;
              color: #fff;
            }

            .select:hover {
              background: #1cba9f !important;
              color: #fff;
            }

            .select:focus {
              background: #1cba9f !important;
              color: #fff;
            }
          }

          input {
            width: 100%;
            border-color: #e9e9e9 !important;
            border-width: 1px;
            border-style: solid;
            color: #3b3b3b;
            font-family: Arial;
            font-size: 15px;
            line-height: 18px;
            font-style: normal;
            font-weight: 400;
            letter-spacing: 0px;
            text-transform: none;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-top: 0px;
            margin-bottom: 0px;
            padding-left: 10px;
            background: #e9e9e9;

          }

          .error-img {
            width: 1.8rem;
            height: 0.8rem;
            margin-left: 1rem;
            margin-right: 0.3rem;
            color: #fe0000;
          }

          .sms-speaker {
            color: #fe0000;
            width: 100%;
            text-align: left;
            font-size: 14px;
            cursor: pointer;
            text-decoration: underline;
          }

          .form-btn-send {
            //width:180px;
            min-width: 86px;
            box-sizing: border-box;
            color: #2a2a2a;
            background-color: #fff;
            border-color: #fff;
            border: 2px solid #fff;
            font-family: Arial;
            font-size: 15px;
            line-height: 18px;
            font-style: normal;
            font-weight: 400;
            letter-spacing: 0px;
            text-transform: none;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-top: 0px;
            margin-bottom: 0px;
            margin-left: 5px;

          }

          .input-forms {
            width: auto !important;
          }

          .select-warning {
            display: flex;
            justify-content: left;
            align-items: center;
          }

          .checekboxs-div {
            text-align: left !important;
            width: 19px !important;
            display: flex;
            justify-content: left;
            align-items: center;
          }

          .checekboxs {
            clear: both;
            -webkit-writing-mode: horizontal-tb !important;
            text-rendering: auto;
            color: -internal-light-dark-color(black, white);
            letter-spacing: normal;
            word-spacing: normal;
            text-transform: none;
            text-indent: 0px;
            text-shadow: none;
            display: inline-block;
            text-align: start;
            margin: 0 0;

          }

          .warning {
            color: #fff;
            width: 100%;
            text-align: left;
            margin-left: 5px;
            font-family: AlibabaPuHuiTi-Light;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
            color: #2a2a2a;

            span {
              color: #1cba9f;
            }
          }

          .submit-div {
            clear: both;
            display: flex;
            justify-content: center;
            text-align: center !important;
          }

          .submit-btn {
            width: 114px;
            border-width: 1px;
            border-style: solid;
            font-family: Arial;
            font-size: 15px;
            line-height: 18px;
            font-style: normal;
            font-weight: 400;
            letter-spacing: 0px;
            text-transform: none;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-top: 0px;
            margin-bottom: 0px;
            color: #ffffff;
            background-color: #1cba9f;
            border-color: #1cba9f;
            border: 2px solid #1cba9f;
            border-radius: 6px;

          }

          .submit-btn:hover {
            color: #51cedd;
            background-color: #ffffff;
            border-color: #ffffff;
          }
        }

        .content-item-input::after {

          content: " ";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          transform: scaleY(.5);
          background-color: #fcfaed;
        }

        .content-item-inputs {
          position: relative;
          margin-bottom: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .select-warning {
            display: flex;
            justify-content: left;
            align-items: center;
          }

          .checekboxs-div {
            text-align: left !important;
            width: 19px !important;
            display: flex;
            justify-content: left;
            align-items: center;
          }

          .checekboxs {
            clear: both;
            -webkit-writing-mode: horizontal-tb !important;
            text-rendering: auto;
            color: -internal-light-dark-color(black, white);
            letter-spacing: normal;
            word-spacing: normal;
            text-transform: none;
            text-indent: 0px;
            text-shadow: none;
            display: inline-block;
            text-align: start;
            margin: 0 0;

          }

        }
      }
    }

    .send_smsspe {
      background: #eeeeee !important;
      border-color: #e9e9e9 !important;
      border-width: 1px !important;
      border-style: solid !important;
      color: #3b3b3b !important;
    }

    .vertifys {
      width: 160px !important;
    }


  }

  .btn_div {
    display: flex;
    justify-content: flex-end;
    text-align: right;
  }

  .btn_down {

    width: 140px;
    height: 40px;
    background-color: #368da7;
    color: #fff;
    border-radius: 50px;
    border: solid 1px #368da7;
    text-decoration: none;
    cursor: pointer;
    font-size: 18px !important;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .baocun {
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;
    margin-left: 5px;
  }

  @media screen and(max-width: 1200px) {
    .search-content {
      width: 95% !important;

    }
    .content-item-left {
      margin-left: 10px !important;
    }
  }

  @media screen and(min-width: 1200px) and(max-width: 1300px) {
    .search-content {
      width: 85% !important;

    }
    .content-item-left {
      margin-left: 20px !important;
    }
  }


</style>


<style type="text/css">
  .nc_scale {
    background: #ddd !important;
    /* 默认背景色 */
  }

  .nc_scale div.nc_bg {
    background: #3CB371 !important;
    /* 滑过时的背景色 */
  }

  .nc_scale .scale_text2 {
    color: #fff !important;
    /* 滑过时的字体颜色 */
  }

  .nc_scale span {
    border: 1px solid #ccc !important;
    height: 35px !important;
    line-height: 35px !important;
  }

  .errloading {
    border: #faf1d5 1px solid !important;
    color: #ef9f06 !important;
  }

  .nc_wrapper {

  }

  .scale_text {
    font-size: 16px !important;
  }
</style>




// WEBPACK FOOTER //
// src/view/search.vue